import React, { useState } from "react";
import { PageTitle } from "../PageTitle";
import i18next from "i18next";
import { OpSenseToastContainer, toast } from "../Toast";
import { Redirect } from "react-router-dom";
import { EventConfigurationsService } from "../../services";
import EventWorkflowConfigurationForm from "./event_workflow_configuration_form";

const EventWorkflowConfigurationAdd = ({ location }) => {
    const [redirect, setRedirect] = useState(false);

    const saveWorkflowConfiguration = (payload) => {
        toast.info("Saving", {autoClose: false});

        EventConfigurationsService
            .createWorkflow(payload)
            .then((_) => {
                setRedirect(true);
            })
            .catch((err) => {
                console.error(err);
                toast.dismiss();
                toast.error("Error creating workflow.");
            });
    };

    return redirect ? (<Redirect to={{ pathname: '/config/events', state: { successMessage: i18next.t('messages.workflow-saved-success') }}} />) : (
        <div>
            <OpSenseToastContainer />

            <div className="row">
                <PageTitle 
                    title={ i18next.t('pages.event-workflow-configurations.add-header') }
                    backLinkWithParams={{ link: { pathname: "/config/events", search: location?.state?.backLinkSearch } }} 
                />
            </div>

            <EventWorkflowConfigurationForm 
                onSaveWorkflowConfiguration={saveWorkflowConfiguration} 
            />
        </div>
    );
};

export default EventWorkflowConfigurationAdd;
